<template>
  <section class="balance-history">
    <p>{{ t('ledgerNote') }}</p>
    <q-card flat bordered><q-form @submit="load(1)"><q-card-section class="row q-col-gutter-md items-start">
      <q-input v-model="filter.account" class="col-12 col-sm-3" type="number" min="1" :label="t('account')" :disable="loading" />
      <q-input v-model="filter.from" class="col-12 col-sm-3" type="date" :label="t('from')" :disable="loading" />
      <q-input v-model="filter.to" class="col-12 col-sm-3" type="date" :label="t('to')" :disable="loading" />
      <div class="col-12 col-sm-3"><q-btn type="submit" color="primary" :label="t('refresh')" :loading="loading" :disable="!filter.account" /></div>
    </q-card-section></q-form></q-card>
    <p v-if="!filter.account">{{ t('selectAccount') }}</p>
    <q-banner v-if="error" class="bg-red-1 text-negative q-my-md" role="alert">{{ t('error') }}</q-banner>
    <template v-if="result">
      <p class="q-mt-md">{{ t('account') }} #{{ result.account }} · {{ result.from }} — {{ result.to }}</p>
      <report-table :title="t('ledgerSummary')" :rows="result.summary" :fields="['currency','opening','incoming','outgoing','closing','count']" row-key="currencyId" />
      <div v-for="currency in result.summary" :key="currency.currencyId">
        <report-trend :title="`${t('incoming')} · ${currency.currency || t('unavailable')}`" :rows="currencyDays(currency.currencyId)" field="incoming" />
        <report-trend :title="`${t('outgoing')} · ${currency.currency || t('unavailable')}`" :rows="currencyDays(currency.currencyId)" field="outgoing" />
      </div>
      <report-table :title="t('records')" :rows="result.records.items" :fields="['id','date','service','value','tax','currency','comment']" />
      <q-pagination :max-pages="7" boundary-numbers direction-links :model-value="result.records.page" :max="Math.max(1, Math.ceil(result.records.total / result.records.perPage))" :disable="loading" @update:model-value="load" />
    </template>
  </section>
</template>
<script>
import { HALApiService } from '../../services/hal-api.service.js';
import ReportTable from './ReportTable.vue';
import ReportTrend from './ReportTrend.vue';
export default {
  name: 'BalanceHistory', components: { ReportTable, ReportTrend }, props: { account: { type: [String, Number], default: '' } },
  data() { const now = new Date().toISOString().slice(0, 10); return { filter: { account: this.account, from: `${now.slice(0, 7)}-01`, to: now }, applied: null, result: null, loading: false, error: false, version: 0 }; },
  watch: { account(value) { this.version += 1; this.loading = false; this.filter.account = value; this.result = null; this.applied = null; this.load(1); } },
  mounted() { if (this.account) this.load(1); }, beforeUnmount() { this.version += 1; },
  methods: {
    t(key) { return this.$t(`reportParity.${key}`); },
    currencyDays(id) { return this.result.daily.filter((row) => row.currencyId === id); },
    async load(page = 1) {
      if (this.loading) return;
      const filter = page === 1 ? { ...this.filter } : { ...this.applied };
      if (!filter.account) return;
      const days = (Date.parse(filter.to) - Date.parse(filter.from)) / 86400000;
      this.error = false; this.result = null;
      if (!Number.isFinite(days) || days < 0 || days >= 366) { this.error = true; return; }
      this.version += 1; const version = this.version; this.loading = true;
      try { const data = await HALApiService.get('/reports/statistics/accounts/balance-history/date', { filter: { ...filter, page } }); if (version === this.version) { this.result = data; this.applied = filter; } }
      catch { if (version === this.version) this.error = true; } finally { if (version === this.version) this.loading = false; }
    },
  },
};
</script>
